import { Input, Form } from '../../../packages/shared/form-feedback/Native';
import { useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { warehouseReturnTo } from '../navigation';

export default function Login() {
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();
  const location = useLocation(); const returnTo = warehouseReturnTo(location.state?.returnTo);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const success = await login(email, password);

    if (success) {
      navigate(returnTo, { replace: true });
    } else {
      setError('Invalid email or password');
    }

    setLoading(false);
  };

  if (isAuthenticated) return <Navigate to={returnTo} replace />;
  return (
    <div className="page" style={{ justifyContent: 'center', padding: '2rem' }}>
      <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
        <h1 style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>📦 Whenly</h1>
        <p style={{ color: 'var(--gray-500)' }}>Warehouse Management</p>
      </div>

      <Form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label" htmlFor="warehouse-email">Email</label>
          <Input
            id="warehouse-email"
            type="email"
            className="form-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            autoComplete="email"
            required
            disabled={loading}
          />
        </div>

        <div className="form-group">
          <label className="form-label" htmlFor="warehouse-password">Password</label>
          <Input
            id="warehouse-password"
            type="password"
            className="form-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            autoComplete="current-password"
            required
            disabled={loading}
          />
        </div>

        {error && (
          <div style={{ color: 'var(--danger)', marginBottom: '1rem', textAlign: 'center' }}>
            {error}
          </div>
        )}

        <button
          type="submit"
          className="btn btn-primary btn-large"
          disabled={loading}
        >
          {loading ? 'Signing in...' : 'Sign In'}
        </button>
      </Form>
    </div>
  );
}
